"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLEAR = exports.TOGGLE_MODAL = exports.SET_SELECTED = exports.LINK_FAILED = exports.LINK_SUCCESS = exports.LINK_REQUEST = exports.FETCH_FAILED = exports.FETCH_SUCCESS = exports.FETCH_REQUEST = void 0;
// Fetch
exports.FETCH_REQUEST = '@sok/project/customerUserGroups/FETCH_REQUEST';
exports.FETCH_SUCCESS = '@sok/project/customerUserGroups/FETCH_SUCCESS';
exports.FETCH_FAILED = '@sok/project/customerUserGroups/FETCH_FAILED';
// Link
exports.LINK_REQUEST = '@sok/project/customerUserGroups/LINK_REQUEST';
exports.LINK_SUCCESS = '@sok/project/customerUserGroups/LINK_SUCCESS';
exports.LINK_FAILED = '@sok/project/customerUserGroups/LINK_FAILED';
// Others
exports.SET_SELECTED = '@sok/project/customerUserGroups/SET_SELECTED';
exports.TOGGLE_MODAL = '@sok/project/customerUserGroups/TOGGLE_MODAL';
exports.CLEAR = '@sok/project/customerUserGroups/CLEAR';
//# sourceMappingURL=customerUserGroups.js.map